import React from 'react';
import InternalDashboardPages from '../../../constants/InternalDashboardPages';
import SimeraDashboard from '../../SimeraDashboard/SimeraDashboard';

const EmployersScreen = () => {
  return <SimeraDashboard page={InternalDashboardPages.EMPLOYERS} />;
};

export default EmployersScreen;
